import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useEffect, useState } from 'react';

dayjs.extend(customParseFormat);

export const useIsBeforeVeda = (time: string): boolean => {
  const [isBefore, setIsBefore] = useState(false);

  useEffect(() => {
    const deadline = dayjs(time, 'DD/MM/YYYY HH:mm');
    const window48h = deadline.subtract(48, 'hour');
    const now = dayjs();
    setIsBefore(now.isAfter(window48h) && now.isBefore(deadline));
  }, [time]);

  return isBefore;
};
